import { Component, ElementRef, EventEmitter, OnInit, Output, Input, ChangeDetectorRef } from '@angular/core';
import moment from 'moment-hijri';
import { ComponentVisibilityService } from 'src/app/services/commonService/component-visibility.service';
import { NgIf, NgFor, NgClass, UpperCasePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { Subject, takeUntil } from 'rxjs';
import { BookingContentService } from 'src/app/services/bookingContentService/booking-content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';

@Component({
  selector: 'app-date-ofbirth',
  templateUrl: './date-ofbirth.component.html',
  styleUrls: ['./date-ofbirth.component.scss'],
  imports: [MatIcon, NgClass, MatButton, UpperCasePipe]
})
export class DateOfbirthComponent implements OnInit {
  isHijri: boolean = false;
  startYear = 1990;
  rangeStep = 24;
  currentRangeStart: number = this.startYear;
  years: Array<{
    disabled: any; gregorian: number; hijri: number
  }> = [];
  months: Array<{
    disabled: any; gregorian: string; hijri: string
  }> = [];
  currentMonth: number | undefined;
  currentYear: number | undefined;
  selectedYear: number = 0;
  selectedHijriYear: any;
  selectedHijriMonth: any
  selectedMonth: string | any | null = null;
  selectedDay: number | null = null;
  allowedYearFlag: any;
  showMonths = false;
  showCalendar = false;
  isNextRange: boolean = false
  yearDisable: boolean = false
  maxYearRange: any
  selectedDate: any;
  @Input() position!: number | string;
  @Input() PassengerTypeCode: string = '';
  @Input() INFtravelerCode: string = '';
  @Output() dateSelected = new EventEmitter<{ isCalenderShow: boolean, date: Date }>();
  @Input() disabled: boolean = false;
  @Input() selectedDOBDateFromParent: Date | null = null;
  @Input() key!: string;
  minDate: any = {
    year: null,
    month: null,
    date: null
  }
  maxDate: any = {
    year: null,
    month: null,
    date: null
  }
  dataRange: any = {
    CHD: { min: 12, max: 2 },
    INS: { min: 2, max: 0 },
    INF: { min: 2, max: 0 },
    ADT: 1
  }
  commonObj: any = {
    headPrevDisabled: false,
    headNextDisabled: false,
  }
  calendarDays: Array<{ day: number | null; hijri: string | null; disabled: boolean; }> = [];
  private destroy$ = new Subject<void>();
  content: any;
  dictionaryContent:any;

  constructor(private visibilityService: ComponentVisibilityService, private elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
    private contentService:BookingContentService,
    private readonly dictionaryContentService: DisctionaryContent
  ) { }
  setMinDateRange(type: number) {
    let year = new Date(new Date().setFullYear(new Date().getFullYear() - type)).getFullYear();
    let month = new Date(new Date().setFullYear(new Date().getFullYear() - type)).getMonth();
    // let date = new Date(new Date().setFullYear(new Date().getFullYear() - type)).getDate();
    let date = new Date(new Date().setDate(new Date().getDate())).getDate();
    this.minDate = { year, month, date };
  }
  setMaxDateRange(maxYear: number) {

    let year = new Date(new Date().setFullYear(new Date().getFullYear())).getFullYear();
    let month = new Date(new Date().setFullYear(new Date().getFullYear())).getMonth();
    let date = new Date(new Date().setDate(new Date().getDate())).getDate();
    this.maxDate = { year, month, date };
  }
  ngOnInit() {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.content = res;
      });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.dictionaryContent = res;
      })
    if (typeof this.position == 'number' || (!!this.position && typeof this.position != 'string')) {
      this.position = `${this.position ?? 76}px`;
    }
    moment.locale('en');
    this.currentMonth = moment().month();
    this.currentYear = moment().year();
    this.setButtonStates()
    if (this.selectedDOBDateFromParent) {
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      this.selectedDate = new Date(this.selectedDOBDateFromParent)
      this.selectedDay = this.selectedDate.getDate()
      this.selectedMonth = monthNames[this.selectedDate.getMonth()]
      this.selectedYear = this.selectedDate.getFullYear()

      this.minDate = {
        year: this.selectedDate.getFullYear(),
        month: this.selectedDate.getMonth(),
        date: this.selectedDate.getDate()
      };
    }


    this.generateYearRange();

  }
  generateYearRange(): void {
    this.visibilityService.getCurrentCalenderStatus().subscribe(($calendarStatus: any) => {
      if (!!$calendarStatus) {
        this.isHijri = $calendarStatus.hijri;
      }
    })
    const currentYear = moment().year();

    let isHijri = false;

    if (this.PassengerTypeCode === 'INS') {
      this.setMinDateRange(this.dataRange.INS.min);
      this.setMaxDateRange(this.dataRange.INS.max);
      this.currentRangeStart = currentYear - 23;
      this.allowedYearFlag = currentYear;
      this.yearDisable = true;
    } else if (this.PassengerTypeCode === 'ADT') {
      this.allowedYearFlag = currentYear;
      this.setMaxDateRange(this.dataRange.ADT);
    } else if (this.PassengerTypeCode === 'CHD') {
      this.setMinDateRange(this.dataRange.CHD.min);
      this.setMaxDateRange(this.dataRange.CHD.max);
      this.currentRangeStart = currentYear - 25;
      this.allowedYearFlag = currentYear - 2;
    } else if (this.PassengerTypeCode === 'INF' || this.INFtravelerCode == 'INF') {
      this.setMinDateRange(this.dataRange.INF.min);
      this.setMaxDateRange(this.dataRange.INF.max);
      this.currentRangeStart = currentYear - 23;
      this.allowedYearFlag = currentYear;
    }

    const yearPairs: { gregorian: number; hijri: number; disabled: boolean }[] = [];
    const rangeEnd = this.currentRangeStart + 24 - 1;

    for (let year = this.currentRangeStart; year <= rangeEnd && year <= this.allowedYearFlag; year++) {
      // for (let year = this.currentRangeStart; year <= rangeEnd; year++) {
      const gregorianYear = year;
      const hijriYear = this.getHijriYear(`${gregorianYear}-01-01`);
      const disabled =
        (this.PassengerTypeCode === 'INS' && (gregorianYear < currentYear - 2 || gregorianYear > currentYear)) ||
        (this.PassengerTypeCode === 'CHD' && gregorianYear >= this.currentRangeStart && gregorianYear < this.currentRangeStart + 12) ||
        (this.PassengerTypeCode === 'INF' && gregorianYear >= this.currentRangeStart && gregorianYear < this.currentRangeStart + 21);

      yearPairs.push({ gregorian: gregorianYear, hijri: hijriYear, disabled: this.minDate.year > gregorianYear });
    }

    this.years = yearPairs;
    isHijri = true;
  }


  calculateAgeFromCurrentDate(): number | null {
    const currentDate = moment();

    if (!this.selectedYear) {
      console.error("Selected year is null or undefined!");
      return null;
    }
    return currentDate.year() - this.selectedYear;
  }

  generateMonthNames(selectedYear: number): void {
    const gregorianMonths = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const hijriMonths: any[] = [];

    for (let i = 0; i < 12; i++) {
      const gregorianDate = moment(`${selectedYear}-01-01`, 'YYYY-MM-DD').add(i, 'months');
      const hijriMonth = gregorianDate.format('iMMM');
      hijriMonths.push(hijriMonth);
    }
    const isMonthDisabled = (monthIndex: number, year: number): boolean => {
      const beforeMinDate =
        year < this.minDate.year ||
        (year === this.minDate.year && monthIndex < this.minDate.month);
      const afterMaxDate =
        year > this.maxDate.year ||
        (year === this.maxDate.year && monthIndex > this.maxDate.month);

      return beforeMinDate || afterMaxDate;
    };
    if (['CHD', 'INS', 'INF'].includes(this.PassengerTypeCode) || this.INFtravelerCode === 'INF') {
      this.months = gregorianMonths.map((gregorianMonth, index) => ({
        gregorian: gregorianMonth,
        hijri: hijriMonths[index],
        disabled: isMonthDisabled(index, selectedYear)
      }));
    } else if (this.PassengerTypeCode === 'ADT') {
      this.months = gregorianMonths.map((gregorianMonth, index) => ({
        gregorian: gregorianMonth,
        hijri: hijriMonths[index],
        disabled: isMonthDisabled(index, selectedYear)
      }));
    } else {
      this.months = gregorianMonths.map((gregorianMonth, index) => ({
        gregorian: gregorianMonth,
        hijri: hijriMonths[index],
        disabled: true
      }));
    }

  }

  getHijriYear(gregorianDate: string): number {
    const date = moment(gregorianDate, 'YYYY-MM-DD');
    return date.iYear();
  }

  selectYear(year: number): void {
    this.selectedYear = year;
    if (this.selectedYear <= this.minDate.year) {
      this.commonObj.headPrevDisabled = true;
      this.commonObj.headNextDisabled = false;
    } else if (this.selectedYear >= this.maxDate.year) {
      this.commonObj.headNextDisabled = true;
      this.commonObj.headPrevDisabled = false;
    } else {
      this.commonObj.headPrevDisabled = false;
      this.commonObj.headNextDisabled = false;
    }
    const hijriDate = moment(`${year}-01-01`, 'YYYY-MM-DD');
    this.selectedHijriYear = hijriDate.iYear();
    this.generateMonthNames(year);
    this.showMonths = true;
    this.showCalendar = false;
    this.cdr.detectChanges();
  }

  selectMonth(month: string): void {
    this.selectedMonth = month;
    if (this.isHijri) {
      const monthIndex = this.months.findIndex((m) => m.gregorian === month);
      if (monthIndex !== -1) {
        const hijriMonthName = moment(`${this.selectedYear}-${monthIndex + 1}-01`, 'YYYY-MM-DD').format('iMMMM'); // Get Hijri month name
        this.selectedHijriMonth = hijriMonthName;
      } else {
        console.error('Invalid month selected:', month);
      }
    }
    this.showCalendar = true;
    this.showMonths = false;
    this.generateCalendarDays();
  }
  selectDay(day: number): void {
    this.selectedDay = day;
    const monthIndex = this.months.findIndex(month => month.gregorian === this.selectedMonth);
    if (monthIndex === -1) {
      console.error("Invalid month selected.");
      return;
    }
    this.selectedDate = new Date();
    this.selectedDate.setDate(day);
    this.selectedDate.setMonth(monthIndex);
    this.selectedDate.setFullYear(this.selectedYear as number);
  }

  setButtonStates(): void {
    if (this.PassengerTypeCode === 'CHD' || this.PassengerTypeCode === 'INF' || this.PassengerTypeCode === 'INS' || this.INFtravelerCode === 'INF') {
      this.commonObj.headPrevDisabled = true;
      this.commonObj.headNextDisabled = true;
    } else {
      this.commonObj.headPrevDisabled = false;
      this.commonObj.headNextDisabled = false;
    }
  }
  nextRange(): void {
    if (this.PassengerTypeCode === 'CHD' || this.PassengerTypeCode === 'INF' || this.PassengerTypeCode === 'INS' || this.INFtravelerCode === 'INF') {
      this.commonObj.headNextDisabled = true;
      this.commonObj.headPrevDisabled = true;
      return;
    }
    this.commonObj.headPrevDisabled = false;
    const currentYear = moment().year();
    const maxAllowedYear = this.maxDate.year;
    if (this.currentRangeStart + this.rangeStep <= maxAllowedYear) {
      this.currentRangeStart += this.rangeStep;
      this.generateYearRange();
    } else {
      this.commonObj.headNextDisabled = true;
      return;
    }
    this.isNextRange = this.currentRangeStart >= maxAllowedYear;
  }
  previousRange(): void {
    if (this.PassengerTypeCode === 'CHD' || this.PassengerTypeCode === 'INF' || this.PassengerTypeCode === 'INS' || this.INFtravelerCode === 'INF') {
      this.commonObj.headNextDisabled = true;
      this.commonObj.headPrevDisabled = true;
      return;
    }
    this.isNextRange = false;
    this.commonObj.headNextDisabled = false;
    if (this.currentRangeStart > 1942) {
      this.currentRangeStart -= 24;
      this.generateYearRange();
    }

    if (this.currentRangeStart === 1942) {
      this.commonObj.headPrevDisabled = true;
    }
  }
  previousMonthRange(): void {
    if (this.selectedYear !== null) {
      if (this.PassengerTypeCode === 'ADT' && this.selectedYear <= 1941) {
        this.commonObj.headPrevDisabled = true;
        return;
      }
      if (
        (this.PassengerTypeCode === 'CHD' ||
          this.PassengerTypeCode === 'INS' ||
          this.PassengerTypeCode === 'INF' ||
          this.INFtravelerCode === 'INF') &&
        this.selectedYear <= this.minDate.year
      ) {
        this.commonObj.headPrevDisabled = true;
        return;
      }
      this.selectedYear -= 1;
      this.selectedHijriYear -= 1;
      this.generateMonthNames(this.selectedYear);
      this.selectedMonth = this.months[11].gregorian;
      if (this.selectedYear < this.maxDate.year) {
        this.commonObj.headNextDisabled = false;
      }
      this.showCalendar = false;
      this.showMonths = true;
    }
  }
  nextMonthRange(): void {
    this.commonObj.headPrevDisabled = false
    if (this.selectedYear >= this.maxDate.year) {
      return;
    }

    if (this.selectedYear !== null) {
      this.maxYearRange = Math.max(...this.years.map(item => item.gregorian));
      this.selectedYear += 1;
      this.selectedHijriYear += 1;
      this.generateMonthNames(this.selectedYear);
      this.selectedMonth = this.months[0].gregorian;
      if (this.selectedYear >= this.maxDate.year) {
        this.commonObj.headNextDisabled = true;
        this.commonObj.headPrevDisabled = false;
      }
      this.showCalendar = false;
      this.showMonths = true;
    }
  }
  previousDayRange(): void {
    if (this.selectedMonth) {
      const currentIndex = this.months.findIndex(month => month.gregorian === this.selectedMonth);
      if (this.PassengerTypeCode === 'CHD' || this.PassengerTypeCode === 'INS' || this.PassengerTypeCode === 'INF' || this.INFtravelerCode === 'INF') {
        if (this.selectedYear < this.minDate.year || (this.selectedYear === this.minDate.year && currentIndex <= this.minDate.month)) {
          this.commonObj.headPrevDisabled = true;
          return;
        }
      }
      if (this.PassengerTypeCode === 'ADT') {
        if (this.selectedYear < 1941 || (this.selectedYear === 1941 && currentIndex <= 0)) {
          this.commonObj.headPrevDisabled = true;
          return;
        }
      }
      this.commonObj.headNextDisabled = false;
      if (currentIndex === 0) {
        const gregorianDate = moment(`${this.selectedYear}-01-01`, 'YYYY-MM-DD').subtract(1, 'month');
        this.selectedMonth = this.months[11].gregorian;
        this.selectedYear = gregorianDate.year();
        this.selectedHijriYear = gregorianDate.iYear();
        this.selectedHijriMonth = gregorianDate.format('iMMM');
      } else {
        const gregorianDate = moment(`${this.selectedYear}-${currentIndex + 1}-01`, 'YYYY-MM-DD').subtract(1, 'month');
        this.selectedMonth = this.months[currentIndex - 1].gregorian;
        this.selectedHijriYear = gregorianDate.iYear();
        this.selectedHijriMonth = gregorianDate.format('iMMM');
      }
      if (this.selectedYear === this.minDate.year && this.months.findIndex(month => month.gregorian === this.selectedMonth) === this.minDate.month) {
        this.commonObj.headPrevDisabled = true;
      } else {
        this.commonObj.headPrevDisabled = false;
      }

      this.showCalendar = true;
      this.generateCalendarDays();
    }
  }

  nextDayRange(): void {

    if (this.selectedMonth) {
      const currentIndex = this.months.findIndex(month => month.gregorian === this.selectedMonth);
      if (this.selectedYear === this.maxDate.year) {
        if (currentIndex >= this.maxDate.month) {
          this.commonObj.headNextDisabled = true;
          return;
        }
      }
      this.commonObj.headPrevDisabled = false;
      if (currentIndex === 11) {
        this.selectedMonth = this.months[0].gregorian;
        this.selectedYear = (this.selectedYear ?? new Date().getFullYear()) + 1; // Increment year
      } else {
        this.selectedMonth = this.months[currentIndex + 1].gregorian;
      }
      if (this.selectedYear > this.maxDate.year || (this.selectedYear === this.maxDate.year && currentIndex + 1 > this.maxDate.month)) {
        this.commonObj.headNextDisabled = true;
        return;
      }
      const gregorianDate = moment(`${this.selectedYear}-${currentIndex + 2}-01`, 'YYYY-MM-DD'); // +2 because months are 0-based in moment
      this.selectedHijriYear = gregorianDate.iYear();
      this.selectedHijriMonth = gregorianDate.format('iMMMM');
      if (this.selectedYear === this.maxDate.year && this.months.findIndex(month => month.gregorian === this.selectedMonth) === this.maxDate.month) {
        this.commonObj.headNextDisabled = true;
      } else {
        this.commonObj.headNextDisabled = false;
      }
      this.showCalendar = true;
      this.generateCalendarDays();
    }
  }
  openLastMonthOfYear(): void {
    if (this.selectedYear !== null) {
      const currentMonthIndex = new Date().getMonth();
      this.selectedMonth = this.months[currentMonthIndex]?.gregorian;
      if (!this.selectedMonth) {
        console.error('Failed to set the selected month. Ensure months are generated correctly.');
        return;
      }

      this.showCalendar = true;
      this.showMonths = false;
    } else {
      console.error('Selected year is null. Unable to open calendar for the current month.');
    }
  }

  generateCalendarDays(): Array<{ day: number | null; hijri: string | null, disabled: boolean }> {
    if (this.selectedYear !== null && this.selectedMonth !== null) {
      const monthIndex = this.months.findIndex(month => month.gregorian === this.selectedMonth);
      const firstDay = new Date(this.selectedYear, monthIndex, 0).getDay();
      const daysInMonth = new Date(this.selectedYear, monthIndex + 1, 0).getDate();
      const days: Array<{ day: number | null; hijri: string | null, disabled: boolean }> = [];
      for (let i = 0; i < firstDay; i++) {
        days.push({ day: null, hijri: null, disabled: false });
      }
      for (let i = 1; i <= daysInMonth; i++) {
        const gregorianDate = moment(`${this.selectedYear}-${monthIndex + 1}-${i}`, 'YYYY-MM-DD');
        const hijriDate = this.isHijri ? gregorianDate.format('iD') : '';
        const isBeforeMinDate =
          this.minDate &&
          (this.selectedYear < this.minDate.year ||
            (this.selectedYear === this.minDate.year && monthIndex < this.minDate.month) ||
            (this.selectedYear === this.minDate.year && monthIndex === this.minDate.month && i < this.minDate.date));

        const isAfterMaxDate =
          this.maxDate &&
          (this.selectedYear > this.maxDate.year ||
            (this.selectedYear === this.maxDate.year && monthIndex > this.maxDate.month) ||
            (this.selectedYear === this.maxDate.year && monthIndex === this.maxDate.month && i > this.maxDate.date));
        days.push({
          day: i,
          hijri: hijriDate,
          disabled: isBeforeMinDate || isAfterMaxDate
        });
      }
      this.calendarDays = days;
    }
    return [];
  }


  onYearRangeClick(): void {
    if (this.selectedYear <= this.minDate.year) {
      this.commonObj.headPrevDisabled = true;
      this.commonObj.headNextDisabled = false;
    } else if (this.selectedYear >= this.maxDate.year) {
      this.commonObj.headNextDisabled = true;
      this.commonObj.headPrevDisabled = false;
    } else {
      this.commonObj.headPrevDisabled = false;
      this.commonObj.headNextDisabled = false;
    }

    if (this.PassengerTypeCode === 'ADT') {
      const lastYear = this.currentRangeStart + 1;
      this.selectedYear = lastYear;
    } else {
      this.selectedYear = this.minDate.year;
    }
    const hijriYear = moment(`${this.selectedYear}-01-01`, 'YYYY-MM-DD').iYear();
    this.generateMonthNames(this.selectedYear);
    this.selectedMonth = this.months[this.maxDate.month]?.gregorian;
    if (this.isHijri) {
      const hijriMonthName = moment(`${this.selectedYear}-12-01`, 'YYYY-MM-DD').format('iMMMM'); // Get Hijri month name
      this.selectedHijriMonth = hijriMonthName;
    }
    if (!this.selectedMonth) {
      console.error('Failed to set the selected month. Ensure months are generated correctly.');
      return;
    }
    this.selectedHijriYear = hijriYear;
    this.showMonths = false;
    this.showCalendar = true;
  }
  backToYearRange(): void {
    if (this.PassengerTypeCode == 'CHD' || this.PassengerTypeCode == 'INS' || this.PassengerTypeCode == 'INF' || this.INFtravelerCode === 'INF') {
      this.commonObj.headPrevDisabled = true;
      this.commonObj.headNextDisabled = true;
    }
    this.showMonths = false;
    this.showCalendar = false;
    this.generateYearRange();
  }
  toggleCalendar() {
    this.isHijri = !this.isHijri;
    this.visibilityService.setCurrentCalenderStatus({ hijri: this.isHijri });
  }
  isDisabledYearExits(): boolean {
    return !!this.years.filter(($year: any) => !!$year.disabled).length;
  }
  confirmSelection() {

    this.dateSelected.emit({ isCalenderShow: true, date: this.selectedDate });
    this.visibilityService.setVisibility('isCallCalendarVisible', false); // Hide component
    this.visibilityService.setVisibility('isCallCalendarVisible0', false);
    this.visibilityService.setVisibility('isDOBCalendarVisible1', false);
    if (!!this.key) {
      this.visibilityService.setVisibility(this.key, false);
    }
  }
}
